var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-table" }, [
    _c("div", { staticClass: "app-table__head" }, [
      _c("table", { staticClass: "app-table__table" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _vm.checkbox
                ? _c("th", { staticClass: "app-table__checkbox" }, [
                    _c(
                      "label",
                      {
                        staticClass: "checkbox",
                        class: {
                          "checkbox--disabled": _vm.isSelectAllDisabled
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.isSelectAllDisabled
                          },
                          domProps: { checked: _vm.isAllSelected },
                          on: { change: _vm.selectAll }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mark" })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.fields, function(field, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    staticClass: "app-table__field",
                    style: field.style
                  },
                  [_c("h6", [_vm._v(_vm._s(field.text))])]
                )
              })
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-table__body", on: { scroll: _vm.handleScroll } },
      [
        (!!_vm.$listeners["end-of-scroll"]
        ? _vm.dataset && _vm.dataset.length
        : !_vm.loading)
          ? _c("table", { staticClass: "app-table__table" }, [
              _c(
                "tbody",
                _vm._l(_vm.dataset, function(item, index) {
                  return _c(
                    "tr",
                    {
                      key: index,
                      staticClass: "app-table__row",
                      class: {
                        "app-table__row--selected":
                          _vm.selected && _vm.isSelected(item),
                        disabled: _vm.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("click", item)
                        }
                      }
                    },
                    [
                      _vm.checkbox
                        ? _c("td", { staticClass: "app-table__checkbox" }, [
                            _c(
                              "label",
                              {
                                staticClass: "checkbox",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked:
                                      _vm.selected && _vm.isSelected(item)
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.select($event, item)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "mark" })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.fields, function(field, index) {
                        return _c(
                          "td",
                          {
                            key: index,
                            staticClass: "app-table__cell",
                            style: field.style
                          },
                          [
                            _vm._t(
                              field.name,
                              [_c("p", [_vm._v(_vm._s(item[field.name]))])],
                              { props: { item: item } }
                            )
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              {
                staticClass: "app-table__loading",
                class: {
                  "app-table__empty": !!_vm.$listeners["end-of-scroll"]
                    ? !_vm.dataset || !_vm.dataset.length
                    : true
                }
              },
              [_vm._t("loading", [_vm._v(" Loading ... ")])],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && (!_vm.dataset || !_vm.dataset.length)
          ? _c(
              "div",
              { staticClass: "app-table__empty" },
              [_vm._t("empty", [_vm._v(" No data found ")])],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37f956cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37f956cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppTable.vue
// module id = null
// module chunks = 